// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__U6fGd","list":"PatternAutocomplete_list__3ym7f"};